<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-steps :active="payStep" :active-color="GetColorMain()">
      <van-step>创建订单</van-step>
      <van-step>支付并提交材料</van-step>
      <van-step>等待财务确认</van-step>
      <van-step>支付完成</van-step>
    </van-steps>
    <div v-if="data" class="baseRect">
      <van-row>
        <van-col span="8" class="titleFont">金额</van-col>
        <van-col span="16" class="rigth titleFont">转账成功后请上传截图</van-col>
      </van-row>
      <div v-if="data.currency==='CNY'" class="priceRect">
        {{ data.currency }} {{ ShowMoney(data.needPayMoney) }}
      </div>
      <div v-if="data.currency!=='CNY'" class="priceRect">
        CNY {{ ShowMoney(data.needPayMoneyCNY) }}
        <div>({{ data.currency }} {{ ShowMoney(data.needPayMoney) }})</div>
      </div>
      <div class="channelRect">
        <img v-if="data && data.channel&& data.channel.qrCodeUrl" :src="data.channel.qrCodeUrl" class="payQrCode"><br v-if="data && data.channel&& data.channel.qrCodeUrl">
        <div v-if="data && data.channel" v-html="data.channel.channelAccount" />
        <!-- 请通过支付宝转账至:<br>xxxxxx@xx.com 成都潜水掌柜 -->
      </div>
      <div class="uploadRect">
        <div v-if="data && data.channel" class="imgRect">
          <div v-if="data && data.channel.referenceImgUrl" class="img" @click="onShowBigImg(data.channel.referenceImgUrl)"><i class="iconfont iconabout" />示例</div>
          <div class="center"><p><i class="iconfont iconadd" /></p>{{ data.channel.name }}</div>
          <div class="imgprivel">
            <van-image
              width="100%"
              height="100%"
              fit="contain"
              :src="upimg"
            />
          </div>
          <div class="imgprivel">
            <van-uploader :after-read="afterRead">
              <div class="uploadButton" />
            </van-uploader>
          </div>
        </div>
        <div class="inputMore">
          <van-field v-model="about" placeholder="请输入支付补充说明" style="background-color: #eee;" />
        </div>
        <div v-if="data.verifyTime && data.payState=='FAIL'" class="failRect" style="color:red;">
          审核失败!请重新提交信息!<br>
          原因:{{ data.systemVerifyAbout }}<br>
          时间:{{ formatDate(data.verifyTime,"yyyy/MM/dd hh:mm:ss",true) }}<br>
        </div>
        <div v-if="data.timePay">提交时间:{{ formatDate(data.timePay,"yyyy/MM/dd hh:mm:ss",true) }}</div>

      </div>
    </div>
    <div v-if="data" class="downButton">
      <van-button type="primary" size="large" :loading="loadingButton" :color="GetColorMain()" @click="onSubjectImageRes">{{ data.timePay?'修改转账资料':'我已经完成转账' }}</van-button>
      <div v-if="data.usageType==='MEMBERCARD'" class="cancelButton" @click="onCancelSubject">取消支付</div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Dialog, Button, ImagePreview, Uploader, Image, Step, Steps, Field, Toast } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, getUrlKey, ShowMoney, compressorImage, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetSystemType, CheckSystemType } from '@/utils/request'
export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
    [Uploader.name]: Uploader,
    [Image.name]: Image,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Field.name]: Field,
    [Toast.name]: Toast,
    TopBar
  },
  data() {
    return {
      titleTop: GetSysTitle(),
      title: '支付界面',
      backurl: '/my/index',
      id: undefined,
      mId: undefined,
      data: undefined,
      image: undefined,
      about: undefined,
      loadingButton: false,
      payStep: 1,
      upimg: '/img/empty.png',
      // payTypeList: [
      //   {
      //     system: 'diveboss',
      //     key: 'WECHAT_TRANSFER',
      //     upimg: '/img/empty.png',
      //     title: '请上传微信转账截图',
      //     img: '/img/payDemoWechat.jpg',
      //     imgQr: '/img/payQrWechat1.jpg',
      //     aboutPay: '请长按二维码,直接付款 潜水小掌柜(徐铮)'
      //   },
      //   { system: 'diveboss',
      //     key: 'ALIPAY_TRANSFER',
      //     upimg: '/img/empty.png',
      //     title: '请上传支付宝转账截图',
      //     img: '/img/payDemoAlipayNew.jpg',
      //     imgQr: '/img/payQrAlipaynew.jpg',
      //     aboutPay: '请长按二维码保存后通过支付宝扫一扫付款<br>或者直接转账给支付宝账号: <br>diveboss@aliyun.com<br>成华区潜掌柜体育用品经营部' },
      //   {
      //     system: 'diveboss',
      //     key: 'BANK',
      //     upimg: '/img/empty.png',
      //     title: '请上传银行转账截图',
      //     img: '/img/payDemoBank.jpg',
      //     aboutPay: '银行卡号: 6221 5323 2002 6727 862 徐铮<br>开户行:成都银行(四川省成都市世纪城支行)' },
      //   {
      //     system: 'diveboss',
      //     key: 'OFFLINE',
      //     upimg: '/img/empty.png',
      //     title: '请上传线下支付截图',
      //     img: '/img/pay_test.jpg',
      //     aboutPay: '请上传支付材料或者联系前台工作人员确认付款信息' },
      //   { system: 'ssi',
      //     key: 'ALIPAY_TRANSFER',
      //     upimg: '/img/empty.png',
      //     title: '请上传支付宝转账截图',
      //     img: '/img/ssi/payDemoAlipay.jpg',
      //     imgQr: '/img/ssi/payQrAlipay.jpg',
      //     aboutPay: '请长按二维码保存后通过支付宝扫一扫付款<br>或者直接转账给支付宝账号: <br>china@divessi.com<br>斯艾（大亚湾）潜水有限公司' }
      // ],
      // item: undefined,
      imageData: undefined,
      imageName: undefined
    }
  },

  created() {
    this.id = this.$route.params.id
    this.mId = getUrlKey('id')
    this.onInit()
  },
  methods: {
    MyNotify,
    CheckSystemType,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    ShowMoney,
    formatDate,

    onInit() {
      if (this.mId) {
        request({
          url: '/Store/orderPayInfoByMoneyId',
          method: 'post',
          params: { moneyId: this.mId }
        }).then(response => {
          this.initData(response)
        })
      } else {
        request({
          url: '/Store/orderPayInfo',
          method: 'post',
          params: { orderId: this.id }
        }).then(response => {
          this.initData(response)
        })
      }
    },
    initData(response) {
      if (!response.success) {
        this.error = true
        return
      }
      console.log(response)
      this.data = response.data
      this.about = this.data.imagesUserAbout
      // var systemType = GetSystemType().toLowerCase()
      // this.item = this.payTypeList.find(item => item.key === this.data.type && item.system === systemType)
      if (this.data.imagesUser) {
        this.upimg = this.data.imagesUser
      } else {
        this.upimg = '/img/empty.png'
      }
      switch (this.data.payState) {
        case 'WAIT':this.payStep = 1; break
        case 'WAIT_PRO':this.payStep = 2; break
        case 'WAIT_SYSTEM':this.payStep = 2; break
        case 'FINISH':this.payStep = 3; break
      }
      // 如果是微信支付的则自动跳转到微信支付页面
      if (this.data.channel.channelType === 'WACHATPAY') {
        var url = '/store/payWechat/' + this.data.orderId
        if (this.data.moneyId) {
          url += '?payOrderId=' + this.data.moneyId
        }
        this.$router.push(url)
      }
    },
    onShowBigImg(img) {
      ImagePreview([img])
    },
    afterRead(file, detail) {
      this.upimg = file.content
      compressorImage(file.file, 1024, 1024, 0.6, (data, fileName) => {
        this.imageData = data
        this.imageName = fileName
      })
    },
    uploadImage(callback) {
      const formData = new FormData()
      console.log('this.imageData', this.imageData)
      if (!this.imageData) {
        if (callback) {
          callback()
        }
        return
      }
      if (this.imageName) {
        formData.append('file', this.imageData, this.imageName)
      } else {
        formData.append('file', this.imageData)
      }
      request({
        url: '/Data/uploadFile?config=paymaterial',
        method: 'post',
        data: formData
      }).then(response => {
        console.log('上传图片反馈', response)
        if (!response.success) {
          this.loadingButton = false
          return
        }
        if (callback) {
          callback(response.data[0].save)
        }
      })
    },
    onSubjectImageRes() {
      this.loadingButton = true
      this.uploadImage((imgurl) => {
        request({
          url: '/store/updatePayImage',
          method: 'post',
          data: {
            moneyId: this.data.moneyId,
            orderId: this.data.orderId,
            image: imgurl,
            body: this.about
          }
        }).then(response => {
          this.loadingButton = false
          if (!response.success) {
            return
          }
          if (response.data.usageType === 'PIC') {
            this.$router.push('/pic/picInfo/' + response.data.orderId)
          } else if (response.data.usageType === 'MEMBERCARD') {
            this.$router.push('/m/' + response.data.orderId)
          } else if (response.data.usageType === 'MEMBERCARDTRIP') {
            this.$router.push('/divetrip/trip/' + response.data.orderId)
          } else if (response.data.usageType === 'MEMBERCARDRESERVE') {
            this.$router.push('/memberCard/memberCardList')
          } else {
            this.$router.push('/store/payFinish/' + response.data.orderId)
          }
          // this.onInit()
          Toast.success({
            message: '支付资料提交成功!,我们将会尽快为您处理！',
            duration: 2000,
            mask: true,
            forbidClick: false,
            onClose: function() {
            }
          })
        })
      })
    },
    onCancelSubject() {
      Dialog.confirm({
        title: '是否要取消支付订单',
        message: '是否取消当前支付订单，请确定你尚未转款!如已经转款请耐心等待!',
        cancelButtonText: '暂不取消',
        confirmButtonText: '立即取消'
      }).then(() => {
        this.onCancelSubjectDo()
      })
    },
    onCancelSubjectDo() {
      request({
        url: '/store/cancelOrderPay',
        method: 'post',
        params: {
          moneyId: this.data.moneyId
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '删除成功!')
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/store/index')
      })
    }
  }
}
</script>
<style scoped>
.baseRect{
  background-color: #fff;
  margin: 1em;
  padding:1em;
  border-radius: 0.5em;
}
.downButton{
  margin: 0 1em 2em 1em;
  border-radius: 0.5em;
  overflow: hidden;
}
.titleFont{
  color: #999;
  font-size: 0.9em;
}
.priceRect{
  text-align:  center;
  font-size: 2em;
  margin: 1em 0;
  font-weight: 700;
}
.priceRect div{
  font-size: 0.5em;
  font-weight: 400;
}
.inputMore {
  margin-top:1em;
}
.channelRect{
  text-align:  center;
  font-size: 0.9em;
  font-weight: 700;
}
.imgRect{
  position: relative;
    margin-top: 1em;
    background-color: #EEE;
    height: 12em;
    text-align: center;
    position: relative;
}
.imgRect  .img{
    position: absolute;
    top:0.5em;
    right: 0.5em;
    color: #333;
    font-size: 0.8em;
    z-index: 10;
}
.imgRect .center{
   padding-top: 4.5em;
   font-size: 0.8em;
   color: #A2A2A2;
}
.imgRect .imgprivel{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.imgRect .uploadButton{
  width: 12em;
  height: 12em;
}
.payQrCode{
  width: 50%;
}
.cancelButton{
  text-align: center;
  margin-top: 0.5em;
  color: #999;
  font-size: 0.9em;
}
</style>
